import { forwardRef, type SVGProps } from 'react';

export const ScaleBalancedIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ScaleBalancedIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 24 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_11017)">
        <path
          d="M9.6 12.4688H9.59925C9.59925 11.8683 9.6495 12.1448 6.40987 5.73303C5.748 4.42344 3.85275 4.42084 3.18975 5.73303C-0.0772502 12.1997 0.00075 11.8872 0.00075 12.4688H0C0 14.1082 2.14913 15.4375 4.8 15.4375C7.45088 15.4375 9.6 14.1082 9.6 12.4688ZM4.8 6.53125L7.5 11.875H2.1L4.8 6.53125ZM23.9993 12.4688C23.9993 11.8683 24.0495 12.1448 20.8099 5.73303C20.148 4.42344 18.2528 4.42084 17.5898 5.73303C14.3228 12.1997 14.4008 11.8872 14.4008 12.4688H14.4C14.4 14.1082 16.5491 15.4375 19.2 15.4375C21.8509 15.4375 24 14.1082 24 12.4688H23.9993ZM16.5 11.875L19.2 6.53125L21.9 11.875H16.5ZM19.8 16.625H13.2V5.68701C14.0816 5.30516 14.7435 4.51881 14.9396 3.5625H19.8C20.1315 3.5625 20.4 3.2968 20.4 2.96875V1.78125C20.4 1.4532 20.1315 1.1875 19.8 1.1875H14.3865C13.839 0.470547 12.9784 0 12 0C11.0216 0 10.161 0.470547 9.6135 1.1875H4.2C3.8685 1.1875 3.6 1.4532 3.6 1.78125V2.96875C3.6 3.2968 3.8685 3.5625 4.2 3.5625H9.06038C9.2565 4.51844 9.918 5.30516 10.8 5.68701V16.625H4.2C3.8685 16.625 3.6 16.8907 3.6 17.2188V18.4062C3.6 18.7343 3.8685 19 4.2 19H19.8C20.1315 19 20.4 18.7343 20.4 18.4062V17.2188C20.4 16.8907 20.1315 16.625 19.8 16.625Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_11017">
          <rect fill="white" height="19" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
});
